module.exports = create

/**
 * Creates a new identity mat2
 *
 * @alias mat2.create
 * @returns {mat2} a new 2x2 matrix
 */
function create() {
  var out = new Float32Array(4)
  out[0] = 1
  out[1] = 0
  out[2] = 0
  out[3] = 1
  return out
}



//////////////////
// WEBPACK FOOTER
// ./~/gl-mat2/create.js
// module id = 79
// module chunks = 0